import { useEffect, useMemo, useState } from 'react';
import { formatPhoneNum } from '../services/phoneNumber.service';

interface UsePhoneFormatterProps {
  value: string;
}

/** Example usage */
// const [InputValue, setInputValue] = useState<string>('');
// const { formattedPhoneValue } = usePhoneFormatter({ formatType: 'US', value: InputValue });
// <input type="text" value={formattedPhoneValue} onChange={(e) => setInputValue(e.target.value) } />
/** */

export const usePhoneFormatter = ({ value }: UsePhoneFormatterProps) => useMemo(() => formatPhoneNum(value), [value]);
type TPhones = 'US';

interface IProps {
  formatType: TPhones;
  value: string;
}

const formatUsPhone = (value: string) =>
  value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})$/, (match, p1, p2, p3) => {
    let formatted = '';
    if (p1) formatted += `+1 (${p1}`;
    if (p2) formatted += `) ${p2}`;
    if (p3) formatted += `-${p3}`;
    return formatted;
  });

/** Example usage */
// const [InputValue, setInputValue] = useState<string>('');
// const { formattedPhoneValue } = usePhoneFormatter({ formatType: 'US', value: InputValue });
// <input type="text" value={formattedPhoneValue} onChange={(e) => setInputValue(e.target.value) } />
/** */

export const useOldPhoneFormatter = ({ formatType, value }: IProps) => {
  const [formattedPhoneValue, setFormattedPhoneValue] = useState<string>('');

  function format() {
    if (!value) return '';
    const cleanValue = value.replace('+1', '').replace(/\D/g, '');
    switch (formatType) {
      case 'US':
        setFormattedPhoneValue(formatUsPhone(cleanValue));
        return '';

      default:
        return '';
    }
  }

  useEffect(() => {
    format();
  }, [value]);

  return { formattedPhoneValue };
};
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Ensure the phone number is in the correct format
  if (phoneNumber.length !== 12 || !phoneNumber.startsWith('+1')) {
    // throw new Error('Invalid phone number format');
    return phoneNumber;
  }

  // Extract the relevant parts of the phone number

  const areaCode = phoneNumber.slice(2, 5);
  const firstThreeDigits = phoneNumber.slice(5, 8);
  const lastFourDigits = phoneNumber.slice(8, 12);

  // Return the formatted phone number with spaces
  return `+1 (${areaCode}) ${firstThreeDigits}-${lastFourDigits}`;
};
